import BaseValidationController from "../admin/controllers/forms/base_validation_controller.js";

export default class extends BaseValidationController {
  static rules = {
    name: { presence: { allowEmpty: false } },
    email: { presence: { allowEmpty: false } },
  };
}
